// extracted by mini-css-extract-plugin
module.exports = {"drawArea":"DrawArea_drawArea__2xoS3","extendedDrawArea":"DrawArea_extendedDrawArea__2ficA"};